module.exports = __webpack_public_path__ + "static/earth-month-final-poster-5505d83fda7f2440716d7ba787f10790.jpg";